import { CMS_SUPPORTED_FILE_EXTENSIONS } from '../constants';

export const downloadFile = async (url: string, filename: string) => {
  // Note that this approach uses the fetch API and creates a blob from
  // the file content, which might not be optimal for very large files.
  // However, it allows us to enforce the filename irrespective of the
  // server's Content-Disposition header. S3 does set the Content-Disposition
  // header, which is why we need to do this. If we find there are performance
  // issues with this approach, we can consider a simpler approach that
  // doesn't use the fetch API + blob, but we'll need to update the S3
  // file name when the user changes the CMSFile title
  const response = await fetch(url);
  const blob = await response.blob();

  // Create a temporary anchor element for downloading
  const a = document.createElement('a');
  a.href = URL.createObjectURL(blob);
  a.download = filename;
  a.style.display = 'none';

  // Trigger download and cleanup
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(a.href);
};

export const hasValidCMSFileExtension = (fileName: string) => {
  const extension = fileName.split('.').pop();
  return extension && CMS_SUPPORTED_FILE_EXTENSIONS.includes(extension.toLowerCase());
};
